import React from 'react';
import { Layout as AntLayout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux';
import LogoutButton from './LogoutButton';
import './Layout.css';

const { Header, Content } = AntLayout;

const navItems = [
  { name: 'Portfolio', path: '/portfolio' },
  { name: 'Services', path: '/services' },
  { name: 'Insights', path: '/insights' },
  { name: 'Company Match', path: '/company-match' },
  { name: 'Contact', path: '/contact' },
];

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const user = useSelector((state: RootState) => state.auth.user);

  return (
    <AntLayout>
      <Header className="top-nav-header">
        <div className="nav-left">
          <Link to="/">
            <img src="/ommax.png" alt="Brand Logo" className="logo" />
          </Link>
        </div>

        <div className="nav-right">
          <Menu
            mode="horizontal"
            selectedKeys={[location.pathname]}
            className="nav-menu"
          >
            {navItems.map((item) => (
              <Menu.Item key={item.path}>
                <Link to={item.path}>{item.name}</Link>
              </Menu.Item>
            ))}
          </Menu>
          {user && <LogoutButton />}
        </div>
      </Header>

      <Content className="main-content">
        <div className="content-box">{children}</div>
      </Content>
    </AntLayout>
  );
};

export default Layout;
